import React from "react";
import "./About.css";
import { Link } from "react-router-dom";
import aboutImage from "../../assets/images/about.webp";

import { FaCheckCircle, FaArrowRight } from "react-icons/fa";

const About = () => {
  return (
    <section className="about1-section" id="about">
      <div className="about1-container">
        {/* LEFT */}

        <div className="about1-content">
          <span className="section1-tag">ABOUT QUALITY SPORTS SURFACE</span>

          <h2>
            Building India's Finest
            <span> Sports Infrastructure</span>
          </h2>

          <div className="title1-line"></div>

          <p>
            Quality Sports Surface is one of India's leading sports
            infrastructure companies specializing in the design, construction,
            resurfacing, and maintenance of world-class sports facilities. Our
            commitment to innovation, premium materials, and international
            construction standards has helped us deliver exceptional projects
            across schools, universities, government organizations, sports
            academies, clubs, and commercial spaces.
          </p>

          <div className="feature-list">
            <div className="feature-item">
              <FaCheckCircle />
              <span>Basketball Courts</span>
            </div>

            <div className="feature-item">
              <FaCheckCircle />
              <span>Tennis Courts</span>
            </div>

            <div className="feature-item">
              <FaCheckCircle />
              <span>Volleyball Courts</span>
            </div>

            <div className="feature-item">
              <FaCheckCircle />
              <span>Pickleball Courts</span>
            </div>

            <div className="feature-item">
              <FaCheckCircle />
              <span>Padle Courts</span>
            </div>

            <div className="feature-item">
              <FaCheckCircle />
              <span>Squash Courts</span>
            </div>

            <div className="feature-item">
              <FaCheckCircle />
              <span>Football Field</span>
            </div>

            <div className="feature-item">
              <FaCheckCircle />
              <span>Badminton Courts</span>
            </div>

            <div className="feature-item">
              <FaCheckCircle />
              <span>Running Tracks</span>
            </div>

            <div className="feature-item">
              <FaCheckCircle />
              <span>Synthetic Turf</span>
            </div>

            <div className="feature-item">
              <FaCheckCircle />
              <span>EPDM & PU Flooring</span>
            </div>
          </div>

          <div className="about-buttons">
            <Link to="/about" className="about-btn">
              Learn More
              <FaArrowRight />
            </Link>
          </div>
        </div>
        {/* RIGHT */}
        <div className="about-image">
          <img src={aboutImage} alt="Quality Sports Surface" />

          <div className="experience-card">
            <h2>15+</h2>

            <span>Years of Excellence</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
